/* eslint-disable no-unused-vars */
import { createSlice } from "@reduxjs/toolkit";
import { isDropdownOpenFlag, getAllNofificationForDashboard, setSelectedDepotDropdownValueForDashboard, setSelectedProjectManagerDashboardDropdownValues } from "src/thunks/dashboard";

const initialState = {
  loading: false,
  allDepots: [],
  goodsInData: [],
  dispatchData: {},
  notificationData: [],
  selectedDepotDropdownValueForDashboard: {},
  isDropdownOpenFlagValue:"",
  dashboardClientAndProjectDropdownValue:{},
  PMDashboardDropdownValues:{}
};

const dashboardSlice = createSlice({
  name: "dashboardSlice",
  reducers: {},
  initialState: initialState,

  extraReducers:
    (builder) => {
      builder

        .addCase(setSelectedDepotDropdownValueForDashboard, (state, action) => {
          state.selectedDepotDropdownValueForDashboard = action.payload; // networkConnectivity
        })

        .addCase(setSelectedProjectManagerDashboardDropdownValues, (state, action) => {
          state.PMDashboardDropdownValues = action.payload;
        })

        .addCase(isDropdownOpenFlag, (state, action) => {
          state.isDropdownOpenFlagValue = action.payload; // networkConnectivity
        })

        // Get all notification data for dashboard
        .addCase(getAllNofificationForDashboard.pending, (state, action) => {
          state.loading = true;
        })
        .addCase(getAllNofificationForDashboard.fulfilled, (state, action) => {
          state.loading = false;
          state.notificationData = action.payload
        })
        .addCase(getAllNofificationForDashboard.rejected, (state, action) => {
          state.loading = false;
        })
    },
});



export default dashboardSlice;
